import { Moment } from "moment";
import { Currency } from "./currency";
import { PaymentType } from "./payment-type";
import { SystemUser } from "./system-user";
import Decimal from 'decimal.js';
import { PaymentOrder } from "./payment-order";

export class SchoolInvoiceWithPaymentOrders {

    public fileId!: number;
    public fileName!: string;

    constructor(
        public invoiceNumber: string,
        public date: Moment,
        public amount: Decimal,
        public currency: Currency,
        public paymentType: PaymentType,
        public comment: string,
        public sortOrder: number | null,
        public paymentOrders: PaymentOrder[],
        public isValid: boolean,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Date,
        public lastModifiedBy?: SystemUser,
        public id?: number,
        public amountInEuro?: Decimal,
        public dueDate?: Moment | null,
        public hidden?: boolean
    ){}
}
